module.exports = __webpack_public_path__ + "img/cryptocoins.symbol.64960f53.svg";